import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class SMClientService {
    getClients = new BehaviorSubject<any>(null);
    getContacts = new BehaviorSubject<any>(null);
    getClientsListView = new BehaviorSubject<any>(null);
    getUserRoles = new BehaviorSubject<Array<UserRoles>>([]);
    getContactCountries = new BehaviorSubject<any>(null);
    getTagDetails = new BehaviorSubject<any>(null);
    getNotifications = new BehaviorSubject<any>(null);
    getUsers = new BehaviorSubject<any>([]);
    getClientDetailsById = new BehaviorSubject<any>([]);
    getCustomFields = new BehaviorSubject<any>([]);
    getTitleList = new BehaviorSubject<any>(null);
    clientCreatedSubject = new BehaviorSubject<any>(null);
    clientCreated$ = this.clientCreatedSubject.asObservable();
    jobCreatedSubject = new BehaviorSubject<any>(null);
    jobCreated$ = this.jobCreatedSubject.asObservable();
    timeLogCreatedSubject = new BehaviorSubject<any>(null);
    timeLogCreated$ = this.timeLogCreatedSubject.asObservable();

    constructor() {}

    getData(state: BehaviorSubject<any>) {
        return state.value;
    }

    updateData(state: BehaviorSubject<any>, data: any) {
        state.next(data);
    }

    getStatusFilteredData(status: number) {
        return status == 5 ? this.getClients.value : this.getClients.value?.filter(x => x.Status === jobStatus[status]);
    }

    getStatusFilteredDatas(status: number) {
        return status == 5 ? this.getClients.value : this.getClients.value?.filter(x => x.status === jobStatus[status]);
    }

    notifyClientCreated(client: any) {
        return this.clientCreatedSubject.next(client);
    }

    notifyJobCreated(job: any) {
        return this.jobCreatedSubject.next(job);
    }

    notifyTimeLogCreated(timeLog: any) {
        return this.timeLogCreatedSubject.next(timeLog);
    }

}

class UserRoles {
    role: string
    data: any []
}

const jobStatus = {
    1: 'Active',
    2: 'Prospect',
    3: 'Lost',
    4: 'Archive',
    5: 'All'
}
